/**
 * Columns that fold by the width of their container, never the screen's: two columns in a wide page, one inside a
 * narrow card or on a phone. Screens pick a column count; the breakpoints live here only.
 */
import type { ReactNode } from 'react'
import { cx } from '../cx'
import type { Gap } from './Stack'
import s from './Layout.module.css'

export function Grid({ cols = 2, gap = 'md', children }: { /** Columns when there is room. Folds to 2 then 1 as the box narrows. */ cols?: 2 | 3 | 4; gap?: Gap; children: ReactNode }) {
  return (
    <div className={s.gridBox}>
      <div className={cx(s.grid, s[`cols-${cols}`], s[`gap-${gap}`])}>{children}</div>
    </div>
  )
}
